import styled from 'styled-components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { PRODUCT_CODES } from '_constants/products';
import { refreshActiveProductCode } from '_redux/products/slice';

import BlogHeaderSection from '_components/composed/sections/BlogHeaderSection';
import BlogArticleSection from '_components/composed/sections/BlogArticleSection';
import BlogFooterSection from '_components/composed/sections/BlogFooterSection';

const StyledBlogArticlePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BlogArticlePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(refreshActiveProductCode(PRODUCT_CODES.incLLC));
  }, [dispatch]);

  return (
    <StyledBlogArticlePage>
      <BlogHeaderSection />
      <BlogArticleSection />
      <BlogFooterSection />
    </StyledBlogArticlePage>
  );
};

export default BlogArticlePage;
